<template>
  <Button @click="goToLoanRoute" type="primary">
    {{$t('apply_for_loan')}}
  </Button>
</template>

<script>
export default {
  methods: {
    goToLoanRoute() {
      this.$router.push('apply-for-loan');
    },
  },
};
</script>
